import { render } from "./collection-filter-bar.vue?vue&type=template&id=15a3cb02"
import script from "./collection-filter-bar.vue?vue&type=script&lang=js"
export * from "./collection-filter-bar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__